import { startApp } from '@horof/shared';
import { App } from './App';
import './payments.css';

// Payments are taken by the treasurer and the committee (not readers).
startApp({ allow: ['treasurer', 'committee'], App });
